// src/Dashboard/pages/user/DashboardUser/components/DashboardDrawer.jsx

import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { FaTimes } from "react-icons/fa";

export default function DashboardDrawer({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = "lg",
}) {
  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.documentElement.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const sizeClass =
    size === "xl"
      ? "max-w-5xl"
      : size === "md"
      ? "max-w-xl"
      : "max-w-3xl";

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999]">
      <div
        className="absolute inset-0 bg-slate-950/55 backdrop-blur-sm"
        onClick={onClose}
      />

      <aside
        className={`absolute right-0 top-0 flex h-full w-full ${sizeClass} flex-col overflow-hidden border-l border-slate-200 bg-white shadow-2xl dark:border-slate-800 dark:bg-slate-950`}
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="relative overflow-hidden bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#0f5cc0] px-5 py-5 text-white sm:px-6">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(76,168,47,0.24),transparent_34%)]" />

          <div className="relative flex items-start justify-between gap-4">
            <div>
              <h2 className="text-lg font-bold sm:text-xl font-montserrat">
                {title}
              </h2>
              {subtitle && (
                <p className="mt-1 text-sm leading-6 text-white/85">
                  {subtitle}
                </p>
              )}
            </div>

            <button
              type="button"
              onClick={onClose}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white/15 text-white transition hover:bg-white/25"
              aria-label="Fermer"
              title="Fermer"
            >
              <FaTimes />
            </button>
          </div>
        </header>

        <div className="flex-1 overflow-y-auto p-4 sm:p-6">{children}</div>

        {footer && (
          <footer className="border-t border-slate-200 bg-white/95 px-4 py-3 backdrop-blur dark:border-slate-800 dark:bg-slate-950/95 sm:px-6">
            {footer}
          </footer>
        )}
      </aside>
    </div>,
    document.body
  );
}